import { all, call, put, takeLatest, select, take } from 'redux-saga/effects';
import { COUNTRIES } from '@freightos/design-system';
import { doGet } from 'propera/HTTP';
import { isTestEnv } from 'propera/utils/url';
import preferencesModel from 'propera/preferences';
import { actions as monitoringActions } from 'propera/monitoring';
import { push } from 'microfronts-router';

import { GET_DEALS, NAVIGATE_TO_RESULTS } from 'slimSearch/actions';
import { endpointConstructor } from 'utils';
import { ENDPOINTS } from 'slimSearch/constants';
import { DEALS_LIMIT } from 'slimSearch/components/hotDeals/constants';
import { GET_RECENT_SEARCHES } from 'slimSearch/components/RecentSearches/actions';
import user from 'propera/user';

export function* fetchDeals() {
  try {
    let recentSearchesSelector = [];
    const userIsLoggedIn = yield select(user.isLoggedIn);
    if (userIsLoggedIn) {
      const searches = yield take(GET_RECENT_SEARCHES.SUCCESS);
      recentSearchesSelector = searches.payload;
    }
    const { getPreferences } = preferencesModel;
    const preferences = yield select(getPreferences);

    const recentSearches = recentSearchesSelector
      .map((search) => {
        if (search?.rfqFields?.load?.packages) {
          return {
            destinationCountry: search?.rfqFields?.destinationLocation?.countryID?.value,
            destinationPortCodeOrCity:
              search?.rfqFields?.destinationLocation?.locationCode ??
              search?.rfqFields?.destinationLocation?.addressLines[0]?.split(',')[0],
            loadUnitTypes: search?.rfqFields?.load?.packages[0]?.packagingType
          };
        }
        return null;
      })
      // cleanup nulls
      .filter(Boolean);

    const recentSearchesEncoded = encodeURIComponent(JSON.stringify(recentSearches));

    const endpoint = isTestEnv() ? ENDPOINTS.dealsTest : ENDPOINTS.deals;

    const { data, status } = yield call(
      doGet,
      endpointConstructor(endpoint, {
        country:
          COUNTRIES.find((country) => country.codeIso3 === preferences.country)?.code ?? 'US',
        searches: recentSearchesEncoded,
        limit: DEALS_LIMIT
      })
    );

    if (status === 200) {
      yield put({ type: GET_DEALS.SUCCESS, payload: data });
    }
  } catch (error) {
    yield put(monitoringActions.exceptionReporter(error, false));
  }
}

export function* navigateToResults(action) {
  yield put(push(`/results/${action.payload.rfq}`));
}

export default function* watcher() {
  yield all([
    takeLatest(GET_DEALS.type, fetchDeals),
    takeLatest(NAVIGATE_TO_RESULTS, navigateToResults)
  ]);
}
